import { Component, OnInit } from "@angular/core"
import { Store, Action } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Contact } from "@models/contact"
import { ContactsStore } from "@store/contacts"
import { Absence } from "@models/absence"
import { ModifiedClass } from "@models/modified-class"
import { ClassBetween } from "@models/class-between"
import * as moment from "moment"
import {
  FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT,
  UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT,
  CREATE_ABSENCE,
  FETCH_CONTACT
} from "@reducers/contacts"
import { ContactClassesBetweenParams } from "@services/contact"
import { ContactEffects } from "@reducers/effects/contact"
import { MatrixClassEffects } from "@reducers/effects/matrix-class"
import {
  FETCH_TEACHERS,
  POPULATE_TEACHERS
} from "@reducers/matrix-class"
import { Observable } from "rxjs/Observable"
import { MatrixClassesStore } from "@store/matrix-classes"
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer"
import { ModalService } from "@services/modal"

@Component({
  selector: "absence-form",
  templateUrl: "./absence-form.pug",
})
export class AbsenceFormComponent implements OnInit {

  public isEditing: boolean = false
  public currentStep: number = 1

  public replacementTeacherCompleter: CompleterData

  public teachers: Contact[]
  public teacher: Contact
  public absence: Absence

  constructor(
    public store: Store<AppState>,
    public contactEffects: ContactEffects,
    public matrixClassEffects: MatrixClassEffects,
    public completerService: CompleterService,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.store.select("contactsReducer").subscribe((c: ContactsStore) => {
      this.teacher = c.activeContact
      this.absence = c.editableAbsence

      this.absence.contactId = this.teacher.id
    })
    this.store.select("matrixClassesReducer").subscribe((mc: MatrixClassesStore) => {
      this.teachers = mc.teachers
      this.setupTeacherAutocompleter()
    })

    if (!this.isEditing) { this.setSensibleDefaultDateTimes() }
  }

  setupTeacherAutocompleter() {
    this.replacementTeacherCompleter =
      this.completerService.local(this.teachers, "fullName", "fullName")
  }

  setupAbsenceWithNewModifiedClasses() {
    this.absence.modifiedClasses = []
    this.absence.classesBetween.forEach((cb: ClassBetween) => {
      const modifiedClass: ModifiedClass  = new ModifiedClass()
      modifiedClass.matrixClassId         = cb.matrixClassId

      this.absence.modifiedClasses.push(modifiedClass)
    })
  }

  setSensibleDefaultDateTimes() {
    this.absence.startDateTime  = moment(new Date()).toDate()
    this.absence.endDateTime    = moment(new Date()).add(1, "days").toDate()
  }

  clickedSubmitAbsenceDateTimes() {
    const params: any = <ContactClassesBetweenParams>{
      contactId: this.teacher.id,
      startDateTime: this.absence.startDateTime.toString(),
      endDateTime: this.absence.endDateTime.toString()
    }

    const a = this.contactEffects.classesBetween
    const b = this.matrixClassEffects.fetchTeachers

    Observable.zip(a, b).take(1).subscribe((actions: Action[]) => {
      if (actions[0].type === UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT &&
          actions[1].type === POPULATE_TEACHERS) {
        this.setupAbsenceWithNewModifiedClasses()
        this.nextStep()
      }
    })

    this.store.dispatch(
      { type: FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT, payload: params })
    this.store.dispatch(
      { type: FETCH_TEACHERS })
  }

  clickedCreateAbsence() {
    this.contactEffects.createAbsence.take(1).subscribe((a: Action) => {
      if (a.type == FETCH_CONTACT) {
        this.modalService.closeModal()
      }
    })
    this.store.dispatch({ type: CREATE_ABSENCE, payload: this.absence })
  }

  selectedReplacementTeacher(e: CompleterItem, classBetween: ClassBetween) {
    const modifiedClass: ModifiedClass =
      this.absence.modifiedClasses.find((mc: ModifiedClass) => {
        return mc.matrixClassId === classBetween.matrixClassId
      })

    if (e && e.originalObject) {
      const teacher = e.originalObject as Contact
      modifiedClass.contactId = this.teacher.id
      modifiedClass.date = this.absence.classesBetween.find(
        (cb: ClassBetween) => {
          return cb.matrixClassId === modifiedClass.matrixClassId
        }).date
    }
    else {
      modifiedClass.contactId = null
      modifiedClass.date = null
    }
  }

  changedStartDateTime(inputVal: string) {
    this.absence.startDateTime = new Date(inputVal)
  }

  changedEndDateTime(inputVal: string) {
    this.absence.endDateTime = new Date(inputVal)
  }

  nextStep()      { this.currentStep++ }
  previousStep()  { this.currentStep-- }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/absence-form.ts